import { index } from 'd3'
import { makeXeroLink } from '@local_modules/generic/xero/utilities/xero-links.js'

export function makeColumnDefs (viewParams) {
  const { entities } = viewParams

  const entitiesMap = index(entities, d => d.id)

  const columnDefs = [
    {
      headerName: 'In Entity',
      valueGetter: function (cellParams) {
        return cellParams.data.organisation_name
      },
      pinned: 'left'
    },
    {
      headerName: 'Contact',
      valueGetter: function (cellParams) {
        return cellParams.data.name
      },
      cellRenderer: function (cellParams) {
        const contactOrgId = cellParams.data.accounting_organisation_id
        const entity = entitiesMap.get(contactOrgId)
        const xeroLink = makeXeroLink('Contact', {
          shortCode: entity?.xero_shortcode,
          xeroContactId: cellParams.data.xero_id
        })
        return `${cellParams.value} <a href="${xeroLink}" target="_blank">Xero</a>`
      },
      pinned: 'left'
    },
    {
      headerName: 'Representing',
      valueGetter: function (cellParams) {
        return cellParams.data.group_organisation_name
      },
      pinned: 'left'
    },
    {
      headerName: 'Xero-to-Xero Key',
      valueGetter: function (cellParams) {
        return cellParams.data.xero_network_key
      },
      cellRenderer: function (cellParams) {
        if (cellParams.value === null) {
          const entity = entitiesMap.get(cellParams.data.group_organisation_id)
          console.log('entity', entity, entity?.xero_to_xero)
          return `<div><span class="tag is-warning">Suggestion: Update in Xero</span> <input class="input zen-vertical-align-baseline" value="${entity?.xero_to_xero}" /></div>`
        }

        return `<input class="input" value="${cellParams.value}" />`
      },
      pinned: 'left'
    }
  ]

  return columnDefs
}
